module.exports = __webpack_public_path__ + "6980f5e74397dd4354acf201d4054026.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/racer_red.png
// module id = 653
// module chunks = 0